module.exports = __webpack_public_path__ + "static/sheet-imperative-783e51409f1fbf283dc7dc52135971cc.gif";